import { BadgeCheck, CheckCircle2, KeyRound, Mail } from "lucide-react";
import { site } from "../content/site";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const icons = { KeyRound, BadgeCheck, CheckCircle2, Mail };

export const SecuritySection = () => (
  <section id="security" className="bg-brand" data-testid="security-section">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeader
        eyebrow={site.security.eyebrow}
        heading={site.security.heading}
        subcopy={site.security.intro}
        light
        testid="security-heading"
      />
      <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {site.security.items.map((item, i) => {
          const Icon = icons[item.icon];
          return (
            <Reveal key={item.title} delay={i * 0.08} className="border-t border-white/25 pt-6">
              <Icon className="h-5 w-5 text-white" aria-hidden="true" />
              <h3 className="mt-3 font-heading text-base font-bold text-white">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/75">{item.text}</p>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.15} className="mt-12">
        <a
          href="/contact-us"
          data-testid="security-contact-link"
          className="inline-flex items-center gap-2 rounded-md border border-white/40 px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
        >
          <Mail className="h-4 w-4" aria-hidden="true" />
          Contact our team
        </a>
      </Reveal>
    </div>
  </section>
);
